(function () {
  var jsWrapper = document.getElementById('withdrawal-js');
  if (!jsWrapper) return;

  jsWrapper.classList.remove('hide-content');

  var form = document.getElementById('withdrawal_contact');
  var step1 = document.getElementById('withdrawal-step-1');
  var step2 = document.getElementById('withdrawal-step-2');
  var step3 = document.getElementById('withdrawal-step-3');
  var continueBtn = document.getElementById('withdrawal-continue');
  var subjectInput = document.getElementById('withdrawal_contact-subject');

  function centerWrapper() {
    jsWrapper.style.minHeight = jsWrapper.offsetHeight + 'px';
  }

  function checkSuccess(response) {
    var success;
    if (response) {
      success = response.ok;
    } else {
      success = new URLSearchParams(window.location.search).get('contact_posted') === 'true';
    }
    if (success) {
      var target = document.getElementById('withdrawal-success');
      target.classList.remove('hide-content');
      target.focus();
    } else {
      var loader = document.getElementById('withdrawal-loader');
      loader.style.display = 'block';
      setTimeout(function () {
        loader.style.display = '';
        var target = document.getElementById('withdrawal-error');
        target.classList.remove('hide-content');
        target.focus();
      }, 4000);
    }
  }

  if (new URLSearchParams(window.location.search).has('contact_posted')) {
    centerWrapper();
    step1.classList.add('hide-content');
    step3.classList.remove('hide-content');
    checkSuccess(null);
    return;
  }

  continueBtn.addEventListener('click', function () {
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var order = document.getElementById('withdrawal_contact-order').value;
    var name = document.getElementById('withdrawal_contact-name').value;
    subjectInput.value = subjectInput.value + ' - ' + order + ' - ' + name;

    centerWrapper();
    step1.classList.add('hide-content');
    step2.classList.remove('hide-content');
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      step2.classList.add('hide-content');
      step3.classList.remove('hide-content');
      checkSuccess(response);
    }).catch(function () {
      form.submit();
    });
  });
})();
